import React from 'react';
import PropTypes from 'prop-types';

import Collapse from 'core/components/collapsible-card';
import { Label } from 'core/components/label';
import { FormField } from 'core/components/form';
import { getCategory } from 'core/helpers/scheduled-pp-helper';
import PropertyForm from './form';
import { icons } from './icons';
import useStyles from './schedule-pp.styles';

const Property = ({ item, index, onRemove, removeFromList, disabled, fieldId, fieldName }) => {
  const classes = useStyles();
  const { description } = item;
  const category = getCategory(item);
  return (
    <>
      <Collapse
        classes={{ content: classes.header }}
        content={
          <>
            <img alt={`icon-${index}`} className={classes.categoryIcon} src={icons[category]} />
            <Label type="infoSubtitle">
              {`${description || ''}`.substring(0, 20)}
              {description && description.length > 20 && '...'}
            </Label>
          </>
        }
        contentRight={
          <FormField
            type="remove"
            name="sppRemove"
            disabled={disabled}
            mode="big"
            onClick={() => onRemove(index, removeFromList)}
          />
        }
      >
        <PropertyForm values={item} id={fieldId} name={fieldName} classes={classes} index={index} disabled={disabled} />
      </Collapse>
    </>
  );
};

Property.propTypes = {
  item: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onRemove: PropTypes.func.isRequired,
  removeFromList: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  fieldId: PropTypes.string.isRequired,
  fieldName: PropTypes.string.isRequired
};

Property.defaultProps = {
  disabled: false
};

export default Property;
